import { defineComponent as d } from "vue";
import { guid as a } from "../utils/basic.js";
import "../AlertDialog/AlertDialog.js";
const h = d({
  name: "RichText",
  props: {
    placeholderText: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: "150px"
    },
    modelValue: { type: String, default: "" },
    checkSpaceValue: { type: Boolean, default: !0 },
    textColor: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      ckeditor: null,
      id: ""
    };
  },
  created() {
    this.id = "txt" + a();
  },
  mounted() {
    if (!window.CKEDITOR) {
      console.error("CKEditor not loaded! Please include CKEditor scripts.");
      return;
    }
    const t = this, r = this.modelValue, i = this.placeholderText, o = this.id, n = {
      height: this.height,
      width: "100%",
      // 设置默认内容样式
      contentsCss: `
        body {
          font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
          line-height: 1.8;
        }
      `,
      bodyClass: "ckeditor-content"
    }, l = {
      extraPlugins: "colordialog",
      toolbar: [
        [
          "Bold",
          "Italic",
          "Underline",
          "JustifyLeft",
          "JustifyCenter",
          "JustifyRight",
          "JustifyBlock",
          "Font",
          "FontSize",
          "TextColor",
          "BGColor"
        ]
      ]
    }, s = this.textColor ? { ...n, ...l } : n;
    try {
      this.ckeditor = window.CKEDITOR.replace(o, s);
    } catch (e) {
      console.error("CKEditor initialization failed:", e);
      return;
    }
    this.ckeditor.on("instanceReady", function(e) {
      e.editor.container.$.style.display = "block", i != null && i.length && !(r != null && r.length) ? (e.editor.setData(i), e.editor.document.$.body.style.color = "#999") : e.editor.setData(r), e.editor.on("focus", function() {
        e.editor.document.getBody().getText().trim() === i.trim() && (e.editor.setData(""), e.editor.document.$.body.style.color = "");
      }), e.editor.on("blur", function() {
        e.editor.document.getBody().getText().trim() === "" && (t.$emit("update:modelValue", ""), e.editor.setData(i), e.editor.document.$.body.style.color = "#999");
      });
    }), this.ckeditor.on("change", function(e) {
      e.editor.document.getBody().getText().trim() === i.trim() ? t.$emit("update:modelValue", "") : t.$emit("update:modelValue", e.editor.getData());
    });
  },
  watch: {
    modelValue: function() {
      var t;
      this.ckeditor && this.modelValue !== this.ckeditor.getData() && (!this.checkSpaceValue || ((t = this.modelValue) == null ? void 0 : t.length) > 0) && this.ckeditor.setData(this.modelValue);
    }
  },
  methods: {
    getText() {
      var t, r, i, o;
      return ((o = (i = (r = (t = this.ckeditor) == null ? void 0 : t.document) == null ? void 0 : r.getBody()) == null ? void 0 : i.getText()) == null ? void 0 : o.trim()) || "";
    },
    getHtml() {
      if (!this.ckeditor)
        return "";
      let t = this.ckeditor.getData().trim();
      return t ? this.wrapEntireContent(t) : "";
    },
    // 确保整个内容被包裹在同一个div中
    wrapEntireContent(t) {
      if (!t)
        return "";
      if (this.isSingleRootDiv(t)) {
        const i = t.match(/<div[^>]*style="([^"]*)"/i);
        let o = i ? i[1] : "";
        if (!o.includes("font-family") || !o.includes("line-height")) {
          const n = "font-family: Helvetica Neue, Helvetica, Arial, sans-serif; line-height: 1.8;", l = o ? `${o} ${n}` : n;
          return i ? t.replace(/style="[^"]*"/i, `style="${l}"`) : t.replace(/<div/i, `<div style="${l}"`);
        }
        return t;
      }
      return `<div style="font-family:Helvetica Neue, Helvetica, Arial, sans-serif; line-height:1.8;">${t}</div>`;
    },
    // 检查是否整个内容被单个div包裹
    isSingleRootDiv(t) {
      var n;
      const o = new DOMParser().parseFromString(`<div id="root">${t}</div>`, "text/html").getElementById("root");
      return o ? o.childNodes.length === 1 && ((n = o.firstElementChild) == null ? void 0 : n.tagName) === "DIV" : !1;
    }
  },
  beforeUnmount() {
    this.ckeditor && (this.ckeditor.destroy(), this.ckeditor = null);
  }
});
export {
  h as default
};
